var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_746",
    "data-name": "Raggruppa 746",
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.297,
    height: 47.98,
    viewBox: "0 0 77.297 47.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_253",
    "data-name": "Tracciato 253",
    d: "M2.8,0H6.437V13.376H6.5l6.46-7.116h4.611l-6.1,6.678,6.758,9.918H14.109L8.763,15.006H8.7L6.437,17.431v5.426H2.8Z",
    transform: "translate(-2.8)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_254",
    "data-name": "Tracciato 254",
    d: "M93.2,29.577h3.5v1.59h.06a5.99,5.99,0,0,1,4.552-2.067c3.7,0,6.022,2.286,6.022,6.2V46.173h-3.6V36.255c0-2.445-.894-3.856-3.28-3.856a3.321,3.321,0,0,0-3.637,3.478v10.3H93.2Z",
    transform: "translate(-75.232 -23.316)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_255",
    "data-name": "Tracciato 255",
    d: "M182,37.965c0-5.665,3.657-8.765,7.831-8.765,4.134,0,7.771,3.1,7.771,8.765s-3.4,8.765-7.771,8.765C185.439,46.731,182,43.63,182,37.965Zm12.025,0c0-3.6-1.749-5.545-4.214-5.545s-4.234,1.888-4.234,5.545c0,3.7,1.749,5.545,4.234,5.545C192.276,43.491,194.025,41.563,194.025,37.965Z",
    transform: "translate(-146.382 -23.396)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_256",
    "data-name": "Tracciato 256",
    d: "M272.5,31.5h3.558l2.385,11.548h.06L282.537,31.5h3.28l3.757,11.528h.06l2.7-11.528h3.518L291.8,48.1h-3.5l-4.114-12.462h-.06L279.7,48.1h-3.478Z",
    transform: "translate(-218.895 -25.239)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_530",
    "data-name": "Rettangolo 530",
    width: 15.901,
    height: 3.061,
    transform: "translate(0.04 35.677)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_257",
    "data-name": "Tracciato 257",
    d: "M96.2,124h3.637v7.891h.06a5.972,5.972,0,0,1,4.532-2.107,5.7,5.7,0,0,1,6.082,6.082v10.991h-3.6V136.721a3.541,3.541,0,0,0-7.076-.278v10.415H96.2Z",
    transform: "translate(-77.636 -99.354)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_258",
    "data-name": "Tracciato 258",
    d: "M184.8,161.965c0-5.665,3.657-8.765,7.831-8.765,4.134,0,7.771,3.1,7.771,8.765s-3.4,8.765-7.771,8.765C188.239,170.731,184.8,167.63,184.8,161.965Zm12.045,0c0-3.6-1.749-5.545-4.214-5.545-2.445,0-4.234,1.888-4.234,5.545,0,3.7,1.749,5.545,4.234,5.545C195.1,167.491,196.845,165.563,196.845,161.965Z",
    transform: "translate(-148.626 -122.75)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_259",
    "data-name": "Tracciato 259",
    d: "M274.4,155.5h3.558l2.385,11.548h.06l4.015-11.548h3.28l3.757,11.528h.06l2.7-11.528h3.5L293.7,172.1h-3.5l-4.114-12.462h-.06L281.6,172.1h-3.478Z",
    transform: "translate(-220.417 -124.593)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.c6561312aae0fcf030e2b1efa82bdb54.svg";
export { ForwardRef as ReactComponent };